<template>
    <div role="dialog" class="mobile-toast-popup" :class="{active : visibleWaitingRefundToastPopup}">
        <div class="opacity-bg" @click.prevent="closeWaitingRefundToastPopup('mobileClose')"></div>
        
        <!-- 모바일 태블릿은 토스트팝업, PC는 레이어팝업 형태 -->
        <div class="toast-layout pc-popup">
            <div class="toast-name">환불진행 내역</div>

            <div class="popup-compo-body">
                <div class="compo-info-box mt-0">
                    - 환불 신청 후 계좌입금 완료 시까지 7~14일이 소요됩니다.<br>
                    - 처리중인 환불내역 건은 취소하실 수 없습니다.
                </div>
                <div class="wating-list-wrap">
                    <ul>
                        <li class="wating-list" v-for="(refundInfoItem, refundInfoIndex) in vuexRefundYescoinWaitingInfoList" v-bind:key="refundInfoIndex">
                            <div class="coin-history-item">
                                <div class="item-identifier">
                                    <span class="item-date">{{refundInfoItem.isrtDt}}</span>
                                    <span class="item-holder">{{refundInfoItem.acnutNm}}</span>
                                </div>
                                <div class="item-content">
                                    <div class="item-content-step">
                                        <div>
                                            <p class="item-status">{{refundInfoItem.stateNm}}</p>
                                            <p class="item-core color-warning">{{Number(refundInfoItem.reqRefundAmt).toLocaleString()}}원</p>
                                        </div>
                                        <div>
                                            <template v-if="refundInfoItem.stateCd === 'WAIT'">
                                                <button type="button" class="btn--yescoin-cancel" @click="cancelRequestedRefund(refundInfoItem.yescoinRefundId)">환불 취소하기</button>
                                            </template>   
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </li>
                    </ul>
                </div>   
                <div class="compo-form-body mt-0">
                    <button type="button" @click="closeWaitingRefundToastPopup" class="btn-l btn-p">확인</button>
                </div>
            </div>

            <!-- PC 팝업 닫기 아이콘 -->
            <button type="button" @click.prevent="closeWaitingRefundToastPopup('desktopClose')" class="position-absolute i-x tablet-none" aria-label="환불진행 내역창 닫기">
                <IconClose />
            </button>
        </div>
    </div>
</template>

<script>
import { mapState } from 'vuex';

export default {
    components: {
        IconClose: () => import('@/components/svg-icon/IconClose.vue'), // PC형 팝업닫기 아이콘
    },

    data() {
        return {}
    },

    computed: {
		...mapState({
            userNo: state => state.userNo,
            authentication: state => state.authentication,
            vuexRefundYescoinWaitingInfoList: state => state.refundStore.vuexRefundYescoinWaitingInfoList,
            visibleWaitingRefundToastPopup: state => state.modalStore.modalsObj.visibleWaitingRefundToastPopup
        }),	
	},

    mounted() {
        // 환불진행 URI일 때 모달창 열림
        // if(this.$route.query.name === 'wating-refund'){
        //     this.$store.commit('modalStore/setVisibleWaitingRefundToastPopup', true);
        // }// this.controlBodyScroll();
    },

    watch:{
        visibleWaitingRefundToastPopup(){
            this.controlBodyScroll();
        }
    },

    methods: {
        // 토스트팝업 외부영역 클릭 시 모바일 토스트 팝업 닫기
        closeWaitingRefundToastPopup() {
            this.$store.commit('modalStore/setVisibleWaitingRefundToastPopup', false);
            // this.$router        
            //     .push({ name:"yescoin" })                   // URI 초기화
            //     .catch(
            //         ()=>{} // 같은 페이지 내에서 다시 이동할 때 발생하는 오류 메시지를 무시한다.
            //     );
        },

        // 이중스크롤 제어
        controlBodyScroll(){
            if(this.visibleWaitingRefundToastPopup){
                this.$store.commit('modalStore/bodyScrollHandler');
            }else{
                this.$store.commit('modalStore/restoreBodyScroll');
            }
        },

        // 환불요청 취소
        cancelRequestedRefund(yescoinRefundId){
            const iscancel = confirm('환불 신청을 취소하시겠습니까?');

            if(iscancel){
                // true이면 신청 취소
                this.dispatchCancelYescoinRefund(yescoinRefundId);
            }
        },

        // 예스코인 환불신청 취소 요청
        async dispatchCancelYescoinRefund(yescoinRefundId) {
            try {
                const data = {
                    yescoinRefundId : yescoinRefundId,
                }
                await this.$store.dispatch('refundStore/actionsCancelYescoinRefund', data);
                this.reloadWaitingRefundInfoList();
            } catch (err) {
                alert(err.response.data.message);
                return;
            }
        },

        // 환불진행 내역 재조회
        reloadWaitingRefundInfoList() {
            this.dispatchRefundYescoinWaitingInfoList();
        },

        async dispatchRefundYescoinWaitingInfoList() {
            try {
                await this.$store.dispatch('refundStore/actionsFindAllRefundYescoinWaitingInfoList');
            } catch(err) {
                return;
            }
        },

    },
}
</script>


<style lang="scss" scoped>
@import '@/assets/css/yescoin.scss';

.wating-list-wrap{
    height: fit-content;
    max-height: 45vh;
    overflow: auto;
    padding: 4px;
    margin: 0 -4px;
    
    ul li:last-child{
    .coin-history-item{
            margin-bottom: 0;
        }
    }
}
</style>